import * as angular from 'angular';

import { WidgetBase } from '../../widgets';
import { Helper } from '../../common';
import { DigitalSignatureWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class DigitalSignatureWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration = {};
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    isTitleHidden = true;
    name = definition.title;
    row = 0;
    sizeX = 2;
    sizeY = 8;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}